import { Cancel, Save } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../../api2";
import Helper from "../../../helpers";
import { commonReducerSelector, userSelector } from "../../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  MyForm,
  MyTable,
  MyThaoTac,
  ThongBao,
  scrollToError
} from "../../Lib/componentLibrarys";
import { ValidateSchema, ValidateSchemaAdd, ValidateSchemaUpdate } from "./validate";
import { FormNhapAdd, FormNhapUpdate } from "./form";
import {
  parseDataSaveAdd,
  parseDataSaveUpdate,
  propsToInitialState
} from "./models";

export default function ThongTinTaiKhoan({userName}) {
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const common = useSelector(commonReducerSelector);
  const dataDanhMuc = common?.danhmucs?.data;
  const profile = common?.profile?.data;
  const [chucVuList, setChucVuList] = useState([]);
  const [phongBanList, setPhongBanList] = useState([]);
  const [coQuanQuanLyList, setCoQuanQuanLyList] = useState([]);
  const [rolesByCapList, setRolesByCapList] = useState([]);
  const [doanhNghiepList, setDoanhNghiepList] = useState([]);
  const [coSoSanXuatList, setCoSoSanXuatList] = useState(null);
  const [coSoCheBienList, setCoSoCheBienList] = useState(null);
  const [coSoPhanPhoiList, setCoSoPhanPhoiList] = useState(null);

  const formRef = useRef(null);

  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (userName && !data) {
      setIsLoading(true);
      new Api()
        .GetQuanLyNguoiDungByUserName({ userName: userName })
        .then(data => {
          if (data.code === 200) {
            setData(data?.data?.result);
          }
        })
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
    if (isEmpty(chucVuList)) {
      new Api().GetChucVuList().then(data => {
        if (data.code === 200) {
          setChucVuList(data?.data?.result?.data);
        }
      });
    }
    if (isEmpty(phongBanList)) {
      new Api().GetPhongBanList().then(data => {
        if (data.code === 200) {
          setPhongBanList(data?.data?.result?.data);
        }
      });
    }
    if (isEmpty(coQuanQuanLyList)) {
      new Api().GetCoQuanQuanLyList().then(data => {
        if (data.code === 200) {
          setCoQuanQuanLyList(data?.data?.result?.data);
        }
      });
    }
    if (isEmpty(rolesByCapList)) {
      new Api().GetRolesByCapList().then(data => {
        if (data.code === 200) {
          setRolesByCapList(data?.data?.result);
        }
      });
    }
    if (isEmpty(doanhNghiepList)) {
      new Api().GetListSelectDoanhNghiep({}).then(data => {
        if (data.code === 200) {
          setDoanhNghiepList(data?.data);
        }
      });
    }
    if (isEmpty(coSoSanXuatList)) {
      new Api().GetListCoSoSanXuatOfLoHang().then(data => {
        if (data.code === 200) {
          setCoSoSanXuatList(data?.data);
        }
      });
    }
    if (isEmpty(coSoCheBienList)) {
      new Api().GetListCoSoCheBienOfLoHang().then(data => {
        if (data.code === 200) {
          setCoSoCheBienList(data?.data);
        }
      });
    }
    if (isEmpty(coSoPhanPhoiList)) {
      new Api().GetListCoSoPhanPhoiOfLoHang().then(data => {
        if (data.code === 200) {
          setCoSoPhanPhoiList(data?.data);
        }
      });
    }
  }, [userName]);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = propsToInitialState(
    data,
    chucVuList,
    phongBanList,
    coQuanQuanLyList,
    rolesByCapList,
    profile,
    coSoSanXuatList,
    coSoCheBienList,
    coSoPhanPhoiList
  );

  //List form
  const formNhap = (
    <Formik
      innerRef={f => (formRef.current = f)}
      i
      initialValues={initialState}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={ValidateSchema}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          {(
            <FormNhapUpdate
              values={values}
              errors={errors}
              setFieldValue={setFieldValue}
              chucVuList={chucVuList}
              phongBanList={phongBanList}
              coQuanQuanLyList={coQuanQuanLyList}
              rolesByCapList={rolesByCapList}
              doanhNghiepList={doanhNghiepList}
              coSoCheBienList={coSoCheBienList}
              coSoPhanPhoiList={coSoPhanPhoiList}
              coSoSanXuatList={coSoSanXuatList} 
            />
          )}
        </form>
      )}
    </Formik>
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .Update_QuanLyNguoiDung({
        token: user.access_token,
        data: parseDataSaveUpdate(formRef.current.values)
      })
      .then(res => {
        if (!res || res.code !== 200) {
          //TODO
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: "Cập nhật thông tin thành công" });
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {
        console.log("Done"); // placeholder
      });
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Thông tin tài khoản" },
          ]}
        />
        {formNhap}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 15
        }}
      >
        <MyButton
          onClick={() => navigate(-1)}
          txt="Hủy bỏ"
          color="#888"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Cancel />}
        />
        <p style={{ width: 5 }}></p>
        <MyButton
          onClick={handleSave}
          txt="Lưu thông tin"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Save />}
        />
      </div>
    </>
  );
}
